import AbstractAPI from '@/services/api/AbstractAPI';

export default class LocationsApi extends AbstractAPI {

  constructor(client, options) {
    super(client, options, '/locations');
  }

  find(needle) {
    return this.makeRequest('/', 'get', {params:{search:needle}});
  }
}
